<template>
    <div :style="{ maxHeight: elHeight +'px', overflow: 'auto' }">

        <v-row class="mx-0 py-3" v-if="showCompleted && !newTasksList.length">
            <v-col md="12" class="text-center">
                <div class="no-task-message"><v-icon class="move-up-icon" size="30" color="#02AD0F">mdi-check</v-icon> Great Job! You’re all done</div>
            </v-col>
        </v-row>
        
        <div class="tasks-list" v-if="newTasksList.length">
            <hb-task v-for="item in newTasksList" 
                class="mb-3" 
                :type="item.type"
                :hot-task="item.hotTask"
                :icon="item.icon | getIcon"
                :title="item.title"
                :time="item.time | formatDateServices"
                :assigned-to="item.assignedTo"
                :created-by="item.createdBy" 
                :created-by-time="item.createdByTime | formatLocalDateTimeServices"
                :completed-by="item.completedBy ? item.completedBy : ''"
                :completed-by-time="item.completedByTime | formatLocalDateTimeServices" 
                :updated-by="item.updatedBy" 
                :updated-by-time="item.updatedByTime | formatLocalDateTimeServices"
                :attachments="item.attachments ? item.attachments : ''" 
                :space="item.space"
                :spaceType="item.space ? item.spaceType : ''"
                :expanded.sync="item.expanded"
                :contact-name="item.contactName" 
                :contact-status="item.contactStatus"
                :contact-is-business="item.contactIsBusiness"
                :property="item.property" 
                :button-one="['completed','dismissed'].indexOf(item.status) == -1 && !item.isAutomated ? 'Update' : ''"
                :button-one-loading="item.loadingBtnOne"
                @button-one-click="updateTaskEvent(item)"  
                :button-two="['completed','dismissed'].indexOf(item.status) == -1 && item.isAutomated ? 'Reassign' : ''"
                :button-two-loading="item.loadingBtnTwo"
                @button-two-click="updateTaskAssignees(item)"
                :button-three="['completed','dismissed'].indexOf(item.status) == -1 && item.slug === 'move_out' ? 'Dismiss Task' : ''"
                :button-three-loading="item.loadingBtnThree"
                @button-three-click="updateTaskStatusEvent(item)"
                :status="item.labelStatus"
                :timer-green-value="item.timerGreenValue"
                :timer-red-value="item.timerRedValue"
                :loading="item.showLoading"
                @click="showDetailsEvent(item)">
                    {{ item.details }}
            </hb-task>
            <create-task :task-sub-types="taskTypes" :task-assignees="taskAssignees" :fetch-tasks="fetchContactTask" v-if="showDialog" v-model="showDialog" :task-details="taskDetails" />
            <update-system-task v-model="showAssignDialog" v-if="showAssignDialog" :task-assignees="taskAssignees" :task-details="taskDetails" />
            <task-details :task-details="singleTaskData" :fetch-tasks="fetchContactTask" :primaryRoleProperties="primaryRoleProperties" v-if="showDetailsDialog" v-model="showDetailsDialog" />
        </div>
        <v-skeleton-loader
            v-if="isLoading($options.name)"
            v-for="i in 2"
            type="list-item-avatar, list-item-two-line"
            class="mb-3"
        ></v-skeleton-loader>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProfileTaskItem from '../includes/TaskCenter/ProfileTaskItem';
import ToDo from "../includes/Todo.vue";
import DateRange from '../includes/TaskCenter/DateRange.vue';
import api from '../../assets/api.js';
import { EventBus } from '../../EventBus.js';
import moment from 'moment';
import { notificationMixin } from '../../mixins/notificationMixin.js';

export default {
name: "ContactTasks",
mixins: [notificationMixin],
components: { 
    ToDo, 
    ProfileTaskItem, 
    DateRange,
    'create-task': () => import('../includes/TaskCenterNew/CreateTask.vue'),
    'update-system-task': () => import('../includes/TaskCenterNew/UpdateSystemTask.vue'),
    'task-details': () => import('../includes/TaskCenterNew/TaskDetails.vue'),
 },
props: ['activeView', 'pendingMoveIn', 'contact', 'propertyView'],
data() {
    return {
        showDialog: false,
        timeRange:[{
            title: "Yoday",
        },{
            title: "Yesterday"
        },{
            title: "This Week"
        },{
            title: "Last Month"
        },{
            title: "All Time"
        },{
            title: "Date Range"
        }],
        markedTasks: [],
        showDateRange: false,
        tempTask: [],
        isScrollLoading: false,
        filterEvents: [],
        showFilters: false,
        tasksList: [],
        showCompleted: false,
        showLoader: false,
        isScrollRequest: false,
        tempFilters: [],
        allowScrollRequest: false,
        showDialog: false,
        showAssignDialog: false,
        newTasksList: [],
        isLoadingTask: false,
        singleTaskData: null,
        showDetailsDialog: false,
        showDialog: false,
        taskDetails: {},
        taskAssignees: [],
        taskTypes: {},
        tasksResponse: [],
        intervalValue: null,
        previousContactId: null,
    }
},
created() {
    this.resetTasks();
    this.setMoveInTasks();
    EventBus.$on('reservation_made',  this.eventBusActions);
    EventBus.$on('reset_profile_tasks',  this.eventBusActions);
    this.fetchTaskTypes();
    this.fetchAssignees();
    this.fetchContactTask();
},
mounted() {
    this.getTaskData();
},
destroyed(){
    EventBus.$off('reservation_made',  this.eventBusActions);
    EventBus.$off('reset_profile_tasks',  this.eventBusActions);
    clearInterval(this.intervalValue);
},
computed: {
    ...mapGetters({
        tasks:'profileTasksStore/tasks',
        events: 'profileTasksStore/eventTypes',
        primaryRoleProperties: 'propertiesStore/filtered'
    }),
    elHeight(){
        let pHeight  = document.documentElement.clientHeight;
        let elHeight = pHeight - 305;
        return elHeight;
    },
    uniqueEvents(){
        let arr = [];
        this.events.forEach((el, index) => {
           let found = arr.find( arrEl => arrEl.name == el.name );
           if (!found) {
               arr.push( { id: el.id, name: el.name } )
           }
        });
        return arr;
    },
    checkPendingMoveIns(){
        return this.$props.pendingMoveIn && this.$props.pendingMoveIn.length ? this.$props.pendingMoveIn : [];
    }
},
filters: {
    formatDateServices(value){
        if (!value || moment(value).format('MM/DD/YYYY') == 'Invalid date') return '';
        return moment(value).format('MMM DD, YYYY');
    },
    formatLocalDateTimeServices(value){
        if (!value) return '';
        return moment.utc(value).local().format('MMM DD, YYYY [@] h:mma');
    }
},
methods: {
    updateTaskAssignees(taskObj){
        let foundTask  = this.tasksResponse.find(item => item.id == taskObj.id);

        let assigness = [];
        if(foundTask.meta_data?.Assignees?.Contacts != null){
            assigness = [...foundTask.meta_data?.Assignees?.Contacts?.map(item => {
                return {
                    id: item.id,
                    name: item.first + ' ' + item.last,
                    is_admin: true
                }
            })]
        }

        if(foundTask.meta_data?.Assignees?.Roles != null){
            assigness = [...foundTask?.meta_data?.Assignees?.Roles?.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    is_role: true
                }
            })];
        }
        
        this.taskDetails = {
            ...foundTask,
            assignTo: assigness,
        }

        this.showAssignDialog = true;
    },
    ...mapActions({
        getTasks: 'profileTasksStore/getTasks',
        getEventTypes: 'profileTasksStore/getEventTypes',
        resetTasks: 'profileTasksStore/resetTasks',
        actionFollowUpStatus:"onBoardingStore/actionFollowUpStatus"
    }),
    eventBusActions(){
        this.fetchContactTask();
    },
    markAsRead(index){
        if (this.markedTasks.includes(index)) {
            this.markedTasks.splice(this.markedTasks.indexOf(index), 1);
        } else {
            this.markedTasks.push(index)
        }
    },
    taskItemAction(action){
        
    },

    validateTask(taskData){
        if (taskData && taskData.task_type == 'moveIn') {
            let data = {
                event_type: taskData,
                contact: taskData.contact,
                unit: taskData.unit,
                todo: {
                    id: taskData.id
                }
            }
            return data;
        } else {
            let taskObj = {
                todo: taskData.task
            };
            taskObj.todo.count = taskData.count;
            let task    = taskData.task;

            if (taskData.type === 'group' && taskData.Tasks && taskData.Tasks.length) {
                taskObj.grouped_tasks = taskData.Tasks;
            }

            if (
                task 
                && Object.keys(task).length > 0
                && task.Event
                && Object.keys(task.Event).length
                && task.Event.event_type
                && Object.keys(task.Event.event_type).length) {
                    taskObj.event_type = task.Event.event_type;
                    if (task.Event.Contact && Object.keys(task.Event.Contact).length) {
                        taskObj.contact = task.Event.Contact;
                    }
                    if (task.Event.Lease) {
                        taskObj.unit = task.Event.Lease.Unit;
                        taskObj.lease_id = task.Event.Lease.id;
                        if (!taskObj.contact && task.Event.Lease.Tenants && task.Event.Lease.Tenants.length && task.Event.Lease.Tenants[0].Contact) {
                            taskObj.contact = task.Event.Lease.Tenants[0].Contact;
                        }
                    }
            }
            return ( !taskObj.grouped_tasks && Object.keys(taskObj).length > 0 ) || ( taskObj.grouped_tasks && Object.keys(taskObj).length > 1 ) ? taskObj : null;
        }
    },
    markCompeleted(task){
    },
    getTaskData(ids = ''){
        // this.tasksList = [];
        // this.$emit('disableBtns');
        // let offset = 0;
        // if (this.filterEvents.length && this.isScrollRequest) {
        //     offset = (this.tasksList.length);
        // } else {
        //     offset = (this.tasksList.length - this.$props.pendingMoveIn.length);
        // }
        // let data = {
        //     id: this.$route.params.contact_id,
        //     property_id: this.propertyView,
        //     role_ids: this.rolesIDs
        // }
        // this.getTasks(data).then(r => {
            
        //     if (r.tasks.length == 0 && this.tasks.length === 0) {
        //         this.showCompleted = true;
        //     } else {
        //         this.showCompleted = false;
        //     }

        //     if (r.tasks.length == 0) {
        //         this.allowScrollRequest = false;
        //     } else {
        //         this.allowScrollRequest = true;
        //     }
        //     this.showLoader = false;
        //     this.tempTask = [...this.tempTask, ...r.tasks];
        //     if (this.tempTask && this.tempTask.length) {
        //         this.tempTask.forEach( (sTask, index) => {
        //             let task = this.validateTask(sTask);
        //             if (task) {
        //                 this.tasksList.push(task);
        //             }
        //         });
        //     }
        //     this.tempTask = [];
        //     this.$emit('disableBtns');
        // });
    },
    applyEvents(){
        this.showFilters = false;
        this.filterEvents = this.tempFilters;
        if (!this.isScrollRequest) {
            this.resetLocalTasks();
        }
        let paramIds = '';
        if (this.filterEvents.length) {
            this.filterEvents.forEach(id => {
                paramIds = `${paramIds}&event_type_id[]=${id}`;
            });
        }
        if (!paramIds) {
            this.setMoveInTasks();
        }
        this.getTaskData(paramIds);
    },
    setMoveInTasks(){
        let pending = this.$props.pendingMoveIn && this.$props.pendingMoveIn.length ? this.$props.pendingMoveIn : [];
        if (pending.length) {
            this.tempTask = this.tempTask.concat(pending);
        }
    },
    fetchTasks(flag = true){
        this.showDialog = false;
        this.isScrollRequest = false;
        if(flag)  {
            this.getEventTypes('task');
        }
        this.applyEvents();
    },
    resetLocalTasks(){
        this.tempTask = [];
        this.tasksList = [];
    },
    closeFilter(){
        this.showFilters = false;
        this.tempFilters = [];
    },
    async fetchContactTask() {
        if (!this.contact?.id) return;
        let metadata = await api.get(this, api.CONTACTS + this.$route.params.contact_id + "/get-all-leases-reservations?property_id=" + this.propertyView);
        let associates = [ ...metadata?.Leases?.map(item => {
            return {
                "type": "lease",
                "id": item.id
            }
        }), ...metadata?.Reservations?.map(item => {
            return {
                type: 'lease',
                id: item.lease_id
            }
        })];

        this.newTasksList = [];
        this.tasksResponse = [];
        associates.unshift({ "type": "contact", "id": this.contact.id});
        let filters = {
            "limit": 100,
            "offset": this.newTasksList.length,
            "associated_with": associates,
            "get_all_assigned_to": true,
        }
        let response = await api.post(this, api.TASKS_CENTER + 'all-tasks', filters);
        let pendingTasks = response.tasks?.length ? response.tasks.filter(item => item.status === 'pending') : [];
        EventBus.$emit('set_contact_tasks', pendingTasks);
        if (!response?.tasks?.length) {
            this.showCompleted = true;
            return;
        }
        this.tasksResponse = [...response.tasks];
        this.newTasksList = response.tasks.map(item => {
            let association = '';
            let assignees = '';
            let property = '';
            let attachments = [];
            let contactData = null;
            let meta_data = item.meta_data;
            if (meta_data.Associations?.lease?.length) association = 'contact';
            else if(meta_data.Associations?.space?.length) association = 'space';
            else if(meta_data.Associations?.property?.length) association = 'property';
            else association = undefined;
            // if (association === 'space') {
            //     meta_data.Associations.space[0].property_id = '85B73ubBGy';
            // }
            if (meta_data.Assignees && (meta_data.Assignees.Contacts?.length || meta_data.Assignees.Roles?.length)) {
                let contacts = meta_data.Assignees.Contacts ? meta_data.Assignees.Contacts.map(item => item && item.first + ' ' + item.last) : []
                let roles =  meta_data.Assignees.Roles ? meta_data.Assignees.Roles.map(item => item && item.name) : [];
                assignees = [...contacts, ...roles].join(', ');
            } else assignees = 'Everyone'
            if (association === 'property') {
                let foundProperty = meta_data.Associations?.property[0];
                property = (foundProperty.number ? foundProperty.number + ' - ' : '') + (foundProperty.city ? foundProperty.city + ' - ' : '') + foundProperty.name;
            }
            if (association === 'space' && this.primaryRoleProperties.find(itemInner => itemInner.id === meta_data.Associations?.space[0].Property.id)) {
                let foundProperty = this.primaryRoleProperties.find(itemInner => itemInner.id === meta_data.Associations?.space[0].Property.id);
                property = (foundProperty.number ? foundProperty.number + ' - ' : '') + (foundProperty.city ? foundProperty.city + ' - ' : '') + foundProperty.name;
            }

            if (association === 'contact' && this.primaryRoleProperties.find(itemInner => itemInner.id === meta_data.Associations?.lease[0].Property.id)) {
                let foundProperty = this.primaryRoleProperties.find(itemInner => itemInner.id === meta_data.Associations?.lease[0].Property.id);
                property = (foundProperty.number ? foundProperty.number + ' - ' : '') + (foundProperty.city ? foundProperty.city + ' - ' : '') + foundProperty.name;
            }
            if (meta_data.Attachments.images) attachments.push(meta_data.Attachments.images > 1 ? ' images' : ' image');
            if (meta_data.Attachments.videos) attachments.push(meta_data.Attachments.videos > 1 ? ' videos' : ' video');
            if (meta_data.Attachments.attachments) attachments.push(meta_data.Attachments.attachments > 1 ? ' attachments' : ' attachment');
            if (meta_data.Associations?.lease?.length) {
                contactData = meta_data.Associations?.lease[0].Tenants
            }
            if (meta_data.Associations?.contact?.length) {
                contactData = meta_data.Associations?.contact[0];
                association = 'contact';
            }
            let labelStatus ='';
            if (item.status === 'completed') {
                labelStatus = 'complete';
            } else if(item.status === 'dismissed') {
                labelStatus = 'dismissed';
            } else if(item.is_overdue) {
                labelStatus = 'overdue';
            } else if(item.hot_task && !item.is_overdue) {
                if (this.getTaskColor(item.due_date).color === 'green') {
                    labelStatus = 'timer green';
                } else {
                    labelStatus = 'timer red';
                }
            } else {
                labelStatus = item.status;
            }
            let taskObject = {
                id: item.id,
                slug: meta_data.TaskType.slug,
                lease: association === 'contact' && meta_data.Associations.lease ? meta_data.Associations.lease[0] : null,
                type: association === 'property' ? 'space' : association,
                hotTask: item.hot_task ? true : false,
                icon: meta_data.TaskType.icon,
                isAutomated: meta_data.TaskType.is_automated ? true : false,
                title: meta_data.TaskType.slug === 'other' ? item.title : meta_data.TaskType.name,
                time: item.property_due_date ? item.property_due_date : '',
                due_date: item.due_date,
                assignedTo: assignees,
                createdBy: meta_data.created_by_details && (meta_data.created_by_details.first || meta_data.created_by_details.last) ? meta_data.created_by_details.first + ' ' + meta_data.created_by_details.last : '',
                createdByTime: item.created_at ? item.created_at : '',
                updatedBy: meta_data.modified_by_details && (meta_data.modified_by_details.first || meta_data.modified_by_details.last) ? meta_data.modified_by_details.first + ' ' + meta_data.modified_by_details.last : '', 
                updatedByTime: item.modified_at ? item.modified_at : '',
                attachments: attachments.length ? attachments.join(', ') : '',
                space: association === 'space' ? meta_data.Associations?.space[0].unit_number : association === 'contact' && property ? meta_data.Associations?.lease[0]?.Unit.number  : '',
                spaceType: association === 'contact' && property ? meta_data.Associations?.lease[0]?.Unit.type : association === 'space' ? meta_data.Associations?.space[0].type : '',
                expanded: false,
                showLoading: false,
                contactId: contactData ? contactData.id : '',
                contactName: contactData ? contactData.first + ' ' + contactData.last : '',
                contactStatus: contactData? contactData.contact_status : '',
                contactIsBusiness: contactData?.contact_type == 'Business' ? true : false,
                property: property,
                details: item.details,
                status: item.status,
                labelStatus,
                timerGreenValue: !item.is_overdue && item.hot_task && this.getTaskColor(item.due_date).color === 'green' ? this.getTaskColor(item.due_date).text : '',
                timerRedValue: !item.is_overdue && item.hot_task && this.getTaskColor(item.due_date).color === 'red' ? this.getTaskColor(item.due_date).text : '',
                is_overdue: item.is_overdue ? true : false,
                loadingBtnOne: false,
                loadingBtnTwo: false,
                loadingBtnThree: false
                        
            };
            if (item.status === 'completed' || item.status === 'dismissed') {
                taskObject = {
                    ...taskObject,
                    completedBy: meta_data.status_updated_by_details && (meta_data.status_updated_by_details.first || meta_data.status_updated_by_details.last) ? meta_data.status_updated_by_details.first + ' ' + meta_data.status_updated_by_details.last : '',
                    completedByTime: item.modified_at
                }
            }
            return taskObject
        });
        this.intervalValue = setInterval(() => {
            this.updateTasksTime();
        }, 1000);

    },

    async updateTaskStatusEvent(params) {
        try { 
            params.loadingBtnThree = true;
            await api.post(this, api.TASKS_CENTER + params.id + '/update-status', { status: 'dismissed' });
            this.showMessageNotification({type: 'success', description: "The task has been dismissed succesfully."});
            await this.fetchContactTask();
        } catch (error) {
            this.showMessageNotification({type: 'error', description: error});
        } 
        finally {
            params.loadingBtnThree = false;
        }
    },

    updateTasksTime() {
        let tempTask = this.newTasksList.map(item => {
            return {
                ...item,
                timerGreenValue: !item.is_overdue && item.hotTask && this.getTaskColor(item.due_date).color === 'green' ? this.getTaskColor(item.due_date).text : '',
                timerRedValue: !item.is_overdue && item.hotTask && this.getTaskColor(item.due_date).color === 'red' ? this.getTaskColor(item.due_date).text : ''
            }
        });
        this.newTasksList = [];
        this.newTasksList = tempTask;
    },
    getTaskColor(params) {
        let dbTime = moment.utc(params);
        let currentTime = moment.utc();
        let diffMinutes = currentTime.diff(dbTime, "minutes");
        let diffHours = currentTime.diff(dbTime, "hours");
        let text ='', color = '';
        if (diffHours > 0) {
            text = `${diffHours} hrs ago`;
            color = "red";
        }
        else if(diffMinutes > 5) {
            text = `${diffMinutes} mins`;
            color = "red";
        } else {
            text = `${diffMinutes} mins`;
            color = "green";
        }
        return { text, color };
    },

    async showDetailsEvent(params){
        let { slug, lease } = params;
        params.showLoading = true;

        if(params.status == 'pending'){
            if (slug === 'pending_transfer') {            
                await this.$store.dispatch('onBoardingStore/getPropertyInfo', this.primaryRoleProperties.find(p => p.id === lease.Property.id));
                await this.$store.dispatch('onBoardingStore/getPending', { unit_id: lease.Unit.id });
                let data = {
                    lease_id: lease.Transfer.from_lease_id,
                    contact: {id: lease.Tenants.id},
                    unit_id: lease.Unit.id,
                    transfer: lease.Transfer,
                    property_id: lease.Property.id
                };
                EventBus.$emit('transfer', data);
            } 
            else if (slug === 'pending_move_in') {
                this.actionFollowUpStatus(true);
                await this.$store.dispatch('onBoardingStore/getPropertyInfo', this.primaryRoleProperties.find(p => p.id === lease.Property.id));
                await this.$store.dispatch('onBoardingStore/getPending', { unit_id: lease.Unit.id });
                EventBus.$emit('new_lead');
                // this.setTaskCenterOpen(false);
            } 
            else if (['task', 'task_followup', 'marketing_automation_create_task', 'task_care_call', 'task_first_Call','other','lock_removal','overlock_space','lock_cut','clean_&_prepare_space'].includes(slug))  {
                // this.complete();
                let response = await api.get(this, api.TASKS_CENTER + params.id);
                let { tasks: task } = response;
                if (task.Attachments?.length) {
                    task.mediaFiles = [];
                    for (const element of task.Attachments) {
                        if (element.mimetype.includes('image') || element.mimetype.includes('video')) {
                            let videoThumbnail = '';
                            let isVideo = element.mimetype.includes('video');
                            if (isVideo) {
                                videoThumbnail = await this.createThumbnailFromBase64(element.data_url)
                            }
                            task.mediaFiles.push({
                                "id": element.id,
                                video: isVideo ? true : false,
                                video_src: `data:${element.mimetype};base64,${element.data_url}`,
                                src: isVideo && videoThumbnail ? videoThumbnail : `data:${element.mimetype};base64,${element.data_url}`,
                                thumbnail: videoThumbnail,
                                upload_id: element.upload_id
                            })
                        }
                    }
                };
                task = {
                    ...task,
                    is_overdue: params.is_overdue
                }
                this.singleTaskData = task;
                this.showDetailsDialog = true;
            } 
            else {
                switch (slug) {
                    case 'new_lead'             :
                    case 'new_web_lead'         :
                    case 'cart_abandonment'     :
                    case 'coupon_clicks'        :
                    case 'hotlead'              :
                    case 'reservation_failure'  :
                    case 'lead_follow_up'       :
                    case 'new_reservation'      :
                    case 'new_web_reservation'  :
                    case 'reservation_follow_up':
                        if (slug === 'new_web_lead' || slug === 'new_web_reservation' || slug === 'new_reservation' || slug === 'new_lead' || slug === 'cart_abandonment' || slug === 'coupon_clicks' || slug === 'reservation_failure' || slug === 'hotlead') {
                            let event = {
                                id: params.id,
                                time: params.createdByTime
                            }   
                            this.fetchData(event, params.contactId, lease);
                        } else {
                            this.fetchData(null, params.contactId, lease);
                        }
                        break;
                    case 'collection_calls':
                        let contactData = {...lease.Tenants, Phones: []};
                        let taskData = params;
                        contactData.lease_id = lease.id;
                        contactData.property_id =  lease.Property.id; 
                        let allData = { ...contactData, ...taskData };
                        EventBus.$emit('HB-Navigation:DelinquencyCenter', allData);
                        break;
                    case 'move_out':
                    case 'move_out_cancelled':
                    case 'move_out_confirmation':
                        let data = {
                            property_id: lease.Property.id,
                            lease_id: lease.id,
                            contact: this.contact,
                            unit_id:  lease.Unit.id,
                            move_out_date: params.createdByTime
                        };
                        EventBus.$emit('move_out', data);
                        break;
                    case 'review_rate_change_notification':
                    case 'approve_rate_change':
                        let rateData = {
                            rateChangeType: params.Rate_Change?.reviewed ? 'finalize-rate-change' : 'review-rate-change',
                            rateChangeItem : params.Rate_Change,
                        }
                        EventBus.$emit('rate_change', rateData);
                        break;
                    case 'move_out':
                    case 'auction_day':
                    case 'auction_payment':
                        EventBus.$emit('HB-Navigation:AuctionManager', lease, lease.Tenants.id, 3);
                        break;
                    case 'cut_lock_schedule_auction': 
                        EventBus.$emit('HB-Navigation:AuctionManager', lease, lease.Tenants.id, 0);
                        break;
                    case 'auction_notice_advertisement':
                    case 'space_inventory':
                        // this.complete();
                        EventBus.$emit('HB-Navigation:AuctionManager', lease, lease.Tenants.id, 1);
                        break;
                    // case 'lock_cut':
                    //     this.complete();
                    //     break;
                    case 'generated_rate_change_documents':
                        EventBus.$emit('download_center')
                        break
                    default:
                        break;
                }
            }
        }
        
        params.showLoading = false;
    },

    fetchData(event = null, contact_id, lease = null){
        
        api.get(this, api.CONTACTS + contact_id).then(r => {
            var contact = r.contact;
            var data = {
                contact_id: contact.id,
                lead_first: contact.first,
                lead_last: contact.last
            }

            if(contact.Lead){
                data.lead_time = contact.Lead.created;
                data.id = contact.Lead.id;
            }

            if(lease.Unit && contact.Reservations){
                contact.Reservations.forEach( reservation => {
                    if (reservation.Lease && reservation.Lease.Unit && reservation.Lease.Unit.id == lease.Unit.id) {
                        data.expires = reservation.expires;
                        data.lease_id = reservation.Lease.id;
                        data.reservation_id = reservation.id;
                        data.reservation_time = reservation.created;
                        data.unit_id = reservation.Lease.Unit.id;
                        data.property_id = reservation.Lease.Unit.property_id
                    }
                });
            }
            data.event = event;
            data.selectedLeadId = lease?.Lead ? lease.Lead.id : '';
            // setting follow up status to true as the lead is being followed up from task center 
            this.actionFollowUpStatus(true)
            EventBus.$emit('HB-Navigation:LeadFollowUp', data);
        });
    },
    async updateTaskEvent(params) {
        try {
            this.isLoadingTask = true;
            params.loadingBtnOne = true;
            let response = await api.get(this, api.TASKS_CENTER + params.id);
            let { tasks: task } = response;
            const taskType = Object.values(this.taskTypes).flatMap(item => item).find(itemInner => itemInner.id === task.task_type_id);
            let mediaFiles = [];
            let documents = [];
            let assigness = [...task.Assignees.Contacts.map(item => {
                return {
                    id: item.id,
                    name: item.first + ' ' + item.last,
                    is_admin: true
                }
            }), ...task.Assignees.Roles.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    is_role: true
                }
            })]
            let property = [];
            let association = '';
            if (task.Associations?.lease?.length) association = 'contact';
            else if(task.Associations?.space?.length) association = 'space';
            else if(task.Associations?.property?.length) association = 'property';
            if (association === 'property') {
                property = task.Associations?.property[0];
            }
            if (association === 'space' && this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.space[0].property_id)) {
                let foundProperty = this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.space[0].property_id);
                property = foundProperty;
            }
            if (association === 'contact' && this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.lease[0].Property.id)) {
                let foundProperty = this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.lease[0].Property.id);
                property = foundProperty;
            }
            if (task.Associations?.space?.length) {
                property = this.primaryRoleProperties.find(itemInner => itemInner.id === task.Associations?.space[0].property_id);
            }

            if (task.Attachments?.length) { 
                for (const element of task.Attachments) {
                    if (element.mimetype.includes('image') || element.mimetype.includes('video')) {
                        let videoThumbnail = '';
                        let isVideo = element.mimetype.includes('video');
                        if (isVideo) {
                            videoThumbnail = await this.createThumbnailFromBase64(element.data_url)
                        }
                        mediaFiles.push({
                            "id": element.id,
                            video: isVideo ? true : false,
                            video_src: `data:${element.mimetype};base64,${element.data_url}`,
                            src: isVideo && videoThumbnail ? videoThumbnail : `data:${element.mimetype};base64,${element.data_url}`,
                            thumbnail: videoThumbnail,
                            upload_id: element.upload_id
                        })
                    } else {
                        documents.push(element)
                    }
                }
            }
            this.taskDetails = {
                id: task.id,
                type: taskType && taskType.label.toLowerCase(),
                subType: taskType && taskType.id,
                title: task.title,
                assignTo: assigness,
                association: task.Associations?.contact?.length || task.Associations?.lease?.length ? 3 : task.Associations?.space?.length ? 2 : task.Associations?.property?.length ? 1 : 0,
                selectedProperties: property ? [property] : [],
                details: task.details,
                hotTask: task.hot_task ? true : false,
                dueDate: task.due_date ? task.due_date.split(' ')[0] : '',
                startDate: task.start_date,
                mediaFiles,
                attachments: documents,
                location: task.task_location === 'inside' ? 0 : 1,
                associations: task.Associations ? task.Associations : [],
                status: task.status
            };
            this.showDialog = true;
        } catch (error) {
            this.showMessageNotification({type: 'error', description: error});
        } finally {
            params.loadingBtnOne = false;
        }
    },
    createThumbnailFromBase64(base64Video) {
        return new Promise((resolve, reject) => {
            const video = document.createElement("video");
            video.src = URL.createObjectURL(new Blob([Uint8Array.from(atob(base64Video), c => c.charCodeAt(0))], { type: "video/mp4" }));
            video.muted = true;
            video.autoplay = true;
            video.playsInline = true;

            video.onloadeddata = () => {
                const canvas = document.createElement("canvas");
                canvas.width = 300;
                canvas.height = (video.videoHeight / video.videoWidth) * 300;
                canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
                resolve(canvas.toDataURL("image/png"));
            };

            video.onerror = () => reject("Error loading video");
        });
    },
    async fetchAssignees(){
        let usersRequest = api.get(this, api.ADMIN + 'active/users');
        let rolesRequest = api.get(this, api.ROLES);
        Promise.all([usersRequest, rolesRequest])
        .then(responses => {
            this.taskAssignees = [...responses[0].admins.map( item => { 
                return {
                    id: item.contact_id,
                    name: item.first + ' ' + item.last,
                    is_admin: true
                }
            }), ...responses[1].roles.map( item => {
                return {
                    id: item.id,
                    name: item.name,
                    is_role: true
                }
            })];
        })
    },
    async fetchTaskTypes() {
        let response = await api.get(this, api.TASKS_CENTER + 'task_types');
        let taskBuckets = [
                { value: 'lead', title: 'Lead' },
                { value: 'delinquency', title: 'Delinquency' },
                { value: 'operations', title: 'Operations' },
                { value: 'maintenance', title: 'Maintenance' }
            ];
            taskBuckets.forEach(item => {
            this.taskTypes[item.value] = response.task_types.filter(typeItem => typeItem.label === item.title).sort((a, b) => {
                if (a.name === "Other") return 1;
                if (b.name === "Other") return -1;
                return a.name.localeCompare(b.name);
            });
            this.taskTypes[item.value].unshift({name: 'All Tasks', id: ''})
        });
    },
},
watch: {
    '$props.pendingMoveIn'(value){
        let pending = value && value.length ? value : [];
        if (pending.length) {
            // this.setMoveInTasks();
            // if (!this.isLoading(this.$options.name)) {
            //     this.fetchContactTask(false);
            // }
        }
    },
    contact( newval, oldval) {
         if(newval && typeof(newval) != 'undefined') {
            if (oldval.id){
                this.previousContactId = oldval.id
            }
            this.fetchContactTask();
         }

    },
    '$route.params.contact_id'(){
        this.fetchContactTask();

    },
    propertyView(){
        const leasesinDifferentProperties = this.contact.Leases.some(l => l.Unit.property_id !== this.contact.Leases[0].Unit.property_id);
        if (leasesinDifferentProperties) {
            if (this.previousContactId) {
                this.previousContactId = null;
            } else {
                this.fetchContactTask();
            }
        }
    }
}
}
</script>

<style lang="scss" scoped>
.border-bottom-row {
    &:not(:first-child) {
        border-top: 1px solid #DFE3E8;
    }
    &:last-child{
        border-bottom: 1px solid #DFE3E8;
    }
}
.tasks-counter{
    background-color: #F26500;

    > div{
        font-style: normal;
        font-weight: 500;
        font-size: 28px;
        line-height: 14px;
        color: #fff;

        small {
            font-style: normal;
            font-size: 10px;
            line-height: 16px;
            font-weight: 500;
        }
    }
}
.task-calender{
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #101318;
}
.check-item-outer{
    border-right: 1px solid #C4CDD5;
}
.check-item-circle{
    width: 32px;
    height: 32px;
    left: 27px;
    top: 16px;
    border: 1px solid #C4CDD5;
    box-sizing: border-box;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.check-item-circle.checked{
    background-color: #02AD0F;
    z-index: 11;
}
.list-title{
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
    color: #101318;
}
.list-title:first-of-type + p {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #637381;
    margin-bottom: 0;
    padding-bottom: 5px;
}
.follow-timer{
    font-size: 12px;
    line-height: 16px;
    text-align: right;
    color: #02AD0F;
}
.list-links a{
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #306FB6;
}
.move-up-icon{
    position: relative;
    top: -3px;
}
.move-out-date{
    font-size: 12px;
    line-height: 16px;
    color: #637381;
}
.min-h-35px{
    min-height: 35px;
}
.blurred-row{
    position: relative;
    &::after{
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background: #E6F7E7;
        opacity: 0.6;
    }
}
.no-task-message{
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #101318;
}
.no-border-bottom{
    border-bottom: 0px solid !important;
}
.mxw-83px{
    max-width: 83px;
}
.auto-complete-sign{
    font-size: medium;
    font-weight: 500;
    line-height: 0px;
    color: #C4CDD5;
}
.dashed-border{
    border: 1px dashed #C4CDD5 !important;
}

</style>
